import { useEffect, useState } from "react";
import { DateInput } from "../../../controls";
import type { DateInputChangeEvent } from "../../../controls/DateInput/DateInput";
import { SCHEDULE_END_TYPES, type ScheduleEndType } from "../SchedulerUtils";

interface ScheduleEndOnDateChange {
  type: ScheduleEndType;
  data: string;
}

interface ScheduleEndOnDateProps {
  initialValue?: string;
  // onChange fires with the change object on mount, and with the raw date
  // string on user input — preserving the existing runtime contract.
  onChange: (change: ScheduleEndOnDateChange | string) => void;
}

const isDate = (dateString?: string): boolean => {
  // Regular expression to match YYYY-MM-DD format
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  return regex.test(dateString ?? "");
};

const getValueFromInitialValue = (value?: string): string => {
  return isDate(value)
    ? (value as string)
    : new Date().toISOString().split("T")[0];
};

const ScheduleEndOnDate = ({
  initialValue,
  onChange,
}: ScheduleEndOnDateProps) => {
  const [value, setValue] = useState(getValueFromInitialValue(initialValue));

  useEffect(() => {
    onChange({
      type: SCHEDULE_END_TYPES.DATE,
      data: getValueFromInitialValue(initialValue),
    });
  }, []);

  return (
    <DateInput
      onChange={(emptyStringOrEvent: DateInputChangeEvent | "") => {
        let value: string;
        // when clearing the input - it is firing the function with ''
        if (emptyStringOrEvent === "") {
          value = "";
        } else {
          value = emptyStringOrEvent?.target?.value;
        }

        setValue(value);
        onChange(value);
      }}
      value={value}
    />
  );
};

export default ScheduleEndOnDate;
